import { useState } from 'react';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({});
  // Add desktop hover state management
  const [hoveredDropdown, setHoveredDropdown] = useState(null);
  const [hoveredSubDropdown, setHoveredSubDropdown] = useState(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleMobileDropdown = (key) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {/* Top Bar */}
      <div
        className="w-full py-2 text-white font-bold text-sm"
        style={{ background: 'linear-gradient(90deg, rgba(142, 75, 93, 1) 0%, rgba(239, 77, 93, 1) 100%)' }}
      >
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-4">
              <a href="mailto:kayungacommunityclub@gmail.com" className="flex items-center space-x-1 text-white hover:text-gray-200">
                <span className="icon-envelope-open-o"></span>
                <span className="hidden md:inline">kayungacommunityclub@gmail.com</span>
              </a>
              <a href="tel:+256200917803" className="flex items-center space-x-1 text-white hover:text-gray-200">
                <span className="icon-phone"></span>
                <span className="hidden md:inline">+256 (200) 917 803</span>
              </a>
            </div>
            <div className="flex items-center space-x-4">
              <a href="https://twitter.com/ClubKayunga?s=09" className="flex items-center space-x-1 text-white hover:text-gray-200">
                <span className="icon-twitter"></span>
                <span className="hidden md:inline">Twitter</span>
              </a>
              <a href="https://facebook.com/kayungacommunityclub" className="flex items-center space-x-1 text-white hover:text-gray-200">
                <span className="icon-facebook"></span>
                <span className="hidden md:inline">Facebook</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="w-full bg-white shadow-sm relative z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between py-4">

            {/* Logo */}
            <div className="flex-shrink-0">
              <a href="/">
                <img src="img/log.jpeg" alt="logo" className="h-16 w-auto" />
              </a>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex space-x-8">

              {/* OUR WORK Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setHoveredDropdown('ourWork')}
                onMouseLeave={() => {
                  setHoveredDropdown(null);
                  setHoveredSubDropdown(null);
                }}
              >
                <button className="flex items-center space-x-1 text-black font-bold text-lg hover:text-blue-600 py-2">
                  <span>OUR WORK</span>
                  <svg className={`w-4 h-4 transition-transform ${hoveredDropdown === 'ourWork' ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                {/* First Level Dropdown */}
                <div className={`absolute left-0 top-full mt-0 w-80 bg-white border-t-2 border-red-800 shadow-lg transition-all duration-200 z-[60] ${hoveredDropdown === 'ourWork' ? 'opacity-100 visible' : 'opacity-0 invisible'
                  }`}>

                  {/* Community Health Initiatives */}
                  <div
                    className="relative"
                    onMouseEnter={() => setHoveredSubDropdown('health')}
                    onMouseLeave={() => setHoveredSubDropdown(null)}
                  >
                    <button className="w-full px-4 py-3 text-left text-black hover:bg-gray-50 flex items-center justify-between">
                      <span>Community Health Initiatives</span>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </button>

                    {/* Sub-dropdown */}
                    <div className={`absolute left-full top-0 w-72 bg-white border-t-2 border-red-800 shadow-lg transition-all duration-200 z-[70] ${hoveredSubDropdown === 'health' ? 'opacity-100 visible' : 'opacity-0 invisible'
                      }`}>
                      <a href="/community-hiv" className="block px-4 py-3 text-black hover:bg-gray-50">HIV/AIDS Awareness</a>
                      <a href="/community-tufayo" className="block px-4 py-3 text-black hover:bg-gray-50">Tuberculosis Awareness(TUFAYO)</a>
                      <a href="/project-sanyuka" className="block px-4 py-3 text-black hover:bg-gray-50">Sanyuka Nange Menstrual Management</a>
                    </div>
                  </div>

                  {/* Philanthropic Initiatives */}
                  <div
                    className="relative"
                    onMouseEnter={() => setHoveredSubDropdown('philanthropic')}
                    onMouseLeave={() => setHoveredSubDropdown(null)}
                  >
                    <button className="w-full px-4 py-3 text-left text-black hover:bg-gray-50 flex items-center justify-between">
                      <span>Philanthropic Initiatives</span>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </button>

                    {/* Sub-dropdown */}
                    <div className={`absolute left-full top-0 w-72 bg-white border-t-2 border-red-800 shadow-lg transition-all duration-200 z-[70] ${hoveredSubDropdown === 'philanthropic' ? 'opacity-100 visible' : 'opacity-0 invisible'
                      }`}>
                      <a href="/community-dress" className="block px-4 py-3 text-black hover:bg-gray-50">Dress The Soul</a>
                      <a href="/feed-our-souls" className="block px-4 py-3 text-black hover:bg-gray-50">Feed The Hungry Souls</a>
                      <a href="/kayungaconnect" className="block px-4 py-3 text-black hover:bg-gray-50">Kayunga Connect</a>
                      <a href="/project-yonja" className="block px-4 py-3 text-black hover:bg-gray-50">Yonja Community Clean Up</a>
                      <a href="/project-mynewnormals" className="block px-4 py-3 text-black hover:bg-gray-50">My New Normals</a>
                      <a href="/project-disability" className="block px-4 py-3 text-black hover:bg-gray-50">Pathway to Ability</a>
                      <a href="/kayungacycling" className="block px-4 py-3 text-black hover:bg-gray-50">Vuga Nange Cycling Program</a>
                    </div>
                  </div>

                  {/* Sustainability Development */}
                  <div
                    className="relative"
                    onMouseEnter={() => setHoveredSubDropdown('sustainability')}
                    onMouseLeave={() => setHoveredSubDropdown(null)}
                  >
                    <button className="w-full px-4 py-3 text-left text-black hover:bg-gray-50 flex items-center justify-between">
                      <span>Sustainability Development</span>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </button>

                    {/* Sub-dropdown */}
                    <div className={`absolute left-full top-0 w-72 bg-white border-t-2 border-red-800 shadow-lg transition-all duration-200 z-[70] ${hoveredSubDropdown === 'sustainability' ? 'opacity-100 visible' : 'opacity-0 invisible'
                      }`}>
                      <a href="/sacco" className="block px-4 py-3 text-black hover:bg-gray-50">Community SACCO</a>
                      <a href="/community-book" className="block px-4 py-3 text-black hover:bg-gray-50">Community Book Project</a>
                      <a href="/community-maama-kit" className="block px-4 py-3 text-black hover:bg-gray-50">Community Maama Kit</a>
                    </div>
                  </div>
                </div>
              </div>

              {/* GET INVOLVED Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setHoveredDropdown('getInvolved')}
                onMouseLeave={() => setHoveredDropdown(null)}
              >
                <button className="flex items-center space-x-1 text-black font-bold text-lg hover:text-blue-600 py-2">
                  <span>GET INVOLVED</span>
                  <svg className={`w-4 h-4 transition-transform ${hoveredDropdown === 'getInvolved' ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                <div className={`absolute left-0 top-full mt-0 w-64 bg-white border-t-2 border-red-800 shadow-lg transition-all duration-200 z-[60] ${hoveredDropdown === 'getInvolved' ? 'opacity-100 visible' : 'opacity-0 invisible'
                  }`}>
                  <a href="/fund-our-work" className="block px-4 py-3 text-black hover:bg-gray-50">Fund our Work</a>
                  <a href="/publications" className="block px-4 py-3 text-black hover:bg-gray-50">Publications</a>
                </div>
              </div>

              {/* WHAT WE DO Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setHoveredDropdown('whatWeDo')}
                onMouseLeave={() => setHoveredDropdown(null)}
              >
                <button className="flex items-center space-x-1 text-black font-bold text-lg hover:text-blue-600 py-2">
                  <span>WHAT WE DO</span>
                  <svg className={`w-4 h-4 transition-transform ${hoveredDropdown === 'whatWeDo' ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                <div className={`absolute left-0 top-full mt-0 w-64 bg-white border-t-2 border-red-800 shadow-lg transition-all duration-200 z-[60] ${hoveredDropdown === 'whatWeDo' ? 'opacity-100 visible' : 'opacity-0 invisible'
                  }`}>
                  <a href="/us-we-do-it" className="block px-4 py-3 text-black hover:bg-gray-50">How we do it</a>
                  <a href="/us-we-work" className="block px-4 py-3 text-black hover:bg-gray-50">Where we work</a>
                  <a href="/us-intervene" className="block px-4 py-3 text-black hover:bg-gray-50">How we intervene</a>
                </div>
              </div>

              {/* ABOUT US Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setHoveredDropdown('aboutUs')}
                onMouseLeave={() => setHoveredDropdown(null)}
              >
                <button className="flex items-center space-x-1 text-black font-bold text-lg hover:text-blue-600 py-2">
                  <span>ABOUT US</span>
                  <svg className={`w-4 h-4 transition-transform ${hoveredDropdown === 'aboutUs' ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                <div className={`absolute left-0 top-full mt-0 w-64 bg-white border-t-2 border-red-800 shadow-lg transition-all duration-200 z-[60] ${hoveredDropdown === 'aboutUs' ? 'opacity-100 visible' : 'opacity-0 invisible'
                  }`}>
                  <a href="/story" className="block px-4 py-3 text-black hover:bg-gray-50">Our Story</a>
                  <a href="/about" className="block px-4 py-3 text-black hover:bg-gray-50">Our Mission</a>
                  <a href="/members" className="block px-4 py-3 text-black hover:bg-gray-50">Our Team</a>
                </div>
              </div>

              {/* Direct Links */}
              <a href="/contact-us" className="text-black font-bold text-lg hover:text-blue-600 py-2">CONTACT US</a>

              {/* Donate Button */}
              <a
                href="/fund-our-work"
                className="px-4 py-2 rounded text-white font-bold text-lg hover:opacity-90 transition-opacity"
                style={{ backgroundColor: '#DD7E43' }}
              >
                DONATE
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMobileMenu}
              className="lg:hidden p-2 rounded-md text-black hover:bg-gray-100 focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`lg:hidden bg-white border-t transform transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
            }`}
          style={{
            position: 'fixed',
            top: '0',
            right: '0',
            width: '300px',
            height: '100vh',
            zIndex: 9999,
            boxShadow: isMobileMenuOpen ? '-10px 0 20px -10px rgba(0, 0, 0, 0.1)' : 'none'
          }}
        >
          {/* Mobile Menu Header */}
          <div className="flex items-center justify-between p-4 border-b">
            <button
              onClick={toggleMobileMenu}
              className="p-2 rounded-md text-black hover:bg-gray-100 focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Mobile Menu Items */}
          <div className="p-4 space-y-2 overflow-y-auto" style={{ height: 'calc(100vh - 80px)' }}>

            {/* OUR WORK Mobile Dropdown */}
            <div>
              <button
                onClick={() => toggleMobileDropdown('ourWork')}
                className="w-full flex items-center justify-between p-3 text-left text-black font-bold hover:bg-gray-50 rounded"
              >
                <span>OUR WORK</span>
                <svg
                  className={`w-4 h-4 transition-transform ${openDropdowns.ourWork ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {openDropdowns.ourWork && (
                <div className="ml-4 space-y-1">
                  {/* Community Health Initiatives */}
                  <div>
                    <button
                      onClick={() => toggleMobileDropdown('health')}
                      className="w-full flex items-center justify-between p-2 text-left text-gray-700 hover:bg-gray-50 rounded"
                    >
                      <span>Community Health Initiatives</span>
                      <svg
                        className={`w-4 h-4 transition-transform ${openDropdowns.health ? 'rotate-180' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>

                    {openDropdowns.health && (
                      <div className="ml-4 space-y-1">
                        <a href="/community-hiv" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">HIV/AIDS Awareness</a>
                        <a href="/community-tufayo" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">Tuberculosis Awareness(TUFAYO)</a>
                        <a href="/project-sanyuka" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">Sanyuka Nange Menstrual Management</a>
                      </div>
                    )}
                  </div>

                  {/* Philanthropic Initiatives */}
                  <div>
                    <button
                      onClick={() => toggleMobileDropdown('philanthropic')}
                      className="w-full flex items-center justify-between p-2 text-left text-gray-700 hover:bg-gray-50 rounded"
                    >
                      <span>Philanthropic Initiatives</span>
                      <svg
                        className={`w-4 h-4 transition-transform ${openDropdowns.philanthropic ? 'rotate-180' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>

                    {openDropdowns.philanthropic && (
                      <div className="ml-4 space-y-1">
                        <a href="/community-dress" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">Dress The Soul</a>
                        <a href="/feed-our-souls" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">Feed The Hungry Souls</a>
                        <a href="/kayungaconnect" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">Kayunga Connect</a>
                        <a href="/project-yonja" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">Yonja Community Clean Up</a>
                        <a href="/project-mynewnormals" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">My New Normals</a>
                        <a href="/project-disability" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">Pathway to Ability</a>
                        <a href="/kayungacycling" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">Vuga Nange Cycling Program</a>
                      </div>
                    )}
                  </div>

                  {/* Sustainability Development */}
                  <div>
                    <button
                      onClick={() => toggleMobileDropdown('sustainability')}
                      className="w-full flex items-center justify-between p-2 text-left text-gray-700 hover:bg-gray-50 rounded"
                    >
                      <span>Sustainability Development</span>
                      <svg
                        className={`w-4 h-4 transition-transform ${openDropdowns.sustainability ? 'rotate-180' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>

                    {openDropdowns.sustainability && (
                      <div className="ml-4 space-y-1">
                        <a href="/sacco" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">Community SACCO</a>
                        <a href="/community-book" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">Community Book Project</a>
                        <a href="/community-maama-kit" className="block p-2 text-gray-600 hover:bg-gray-50 rounded">Community Maama Kit</a>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* GET INVOLVED Mobile Dropdown */}
            <div>
              <button
                onClick={() => toggleMobileDropdown('getInvolved')}
                className="w-full flex items-center justify-between p-3 text-left text-black font-bold hover:bg-gray-50 rounded"
              >
                <span>GET INVOLVED</span>
                <svg
                  className={`w-4 h-4 transition-transform ${openDropdowns.getInvolved ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {openDropdowns.getInvolved && (
                <div className="ml-4 space-y-1">
                  <a href="/fund-our-work" className="block p-2 text-gray-700 hover:bg-gray-50 rounded">Fund our Work</a>
                  <a href="/publications" className="block p-2 text-gray-700 hover:bg-gray-50 rounded">Publications</a>
                </div>
              )}
            </div>

            {/* WHAT WE DO Mobile Dropdown */}
            <div>
              <button
                onClick={() => toggleMobileDropdown('whatWeDo')}
                className="w-full flex items-center justify-between p-3 text-left text-black font-bold hover:bg-gray-50 rounded"
              >
                <span>WHAT WE DO</span>
                <svg
                  className={`w-4 h-4 transition-transform ${openDropdowns.whatWeDo ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {openDropdowns.whatWeDo && (
                <div className="ml-4 space-y-1">
                  <a href="/us-we-do-it" className="block p-2 text-gray-700 hover:bg-gray-50 rounded">How we do it</a>
                  <a href="/us-we-work" className="block p-2 text-gray-700 hover:bg-gray-50 rounded">Where we work</a>
                  <a href="/us-intervene" className="block p-2 text-gray-700 hover:bg-gray-50 rounded">How we intervene</a>
                </div>
              )}
            </div>

            {/* ABOUT US Mobile Dropdown */}
            <div>
              <button
                onClick={() => toggleMobileDropdown('aboutUs')}
                className="w-full flex items-center justify-between p-3 text-left text-black font-bold hover:bg-gray-50 rounded"
              >
                <span>ABOUT US</span>
                <svg
                  className={`w-4 h-4 transition-transform ${openDropdowns.aboutUs ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {openDropdowns.aboutUs && (
                <div className="ml-4 space-y-1">
                  <a href="/story" className="block p-2 text-gray-700 hover:bg-gray-50 rounded">Our Story</a>
                  <a href="/about" className="block p-2 text-gray-700 hover:bg-gray-50 rounded">Our Mission</a>
                  <a href="/members" className="block p-2 text-gray-700 hover:bg-gray-50 rounded">Our Team</a>
                </div>
              )}
            </div>

            {/* Direct Links */}
            <a href="/contact-us" className="block p-3 text-black font-bold hover:bg-gray-50 rounded">CONTACT US</a>

            {/* Donate Button */}
            <a
              href="/fund-our-work"
              className="block p-3 rounded text-white font-bold text-center hover:opacity-90 transition-opacity mt-4"
              style={{ backgroundColor: '#DD7E43' }}
            >
              DONATE
            </a>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        {isMobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={toggleMobileMenu}
          />
        )}
      </header>
      {/* Enhanced Floating Action Buttons */}
      <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-4">
        {/* Donate Button */}
        <div className="group relative">
          <button
            onClick={() => window.location.href = '/fund-our-work'}
            className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 rounded-2xl shadow-2xl flex items-center justify-center text-white transform hover:scale-110 transition-all duration-300 animate-pulse hover:animate-none"
          >
            <svg className="w-6 h-6 md:w-7 md:h-7" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
            </svg>
          </button>

          {/* Tooltip */}
          <div className="absolute right-full top-1/2 -translate-y-1/2 mr-3 bg-black/80 text-white px-3 py-2 rounded-lg text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
            <div className="flex items-center gap-2">
              Support Our Cause
            </div>
            <div className="absolute top-1/2 -translate-y-1/2 -right-1 w-2 h-2 bg-black/80 rotate-45"></div>
          </div>
        </div>

        {/* Our Story Button */}
        <div className="group relative">
          <button
            onClick={() => window.location.href = '/story'}
            className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-r from-blue-500 to-cyan-600 hover:from-blue-600 hover:to-cyan-700 rounded-2xl shadow-2xl flex items-center justify-center text-white transform hover:scale-110 transition-all duration-300"
          >
            <svg className="w-6 h-6 md:w-7 md:h-7" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
            </svg>
          </button>

          {/* Tooltip */}
          <div className="absolute right-full top-1/2 -translate-y-1/2 mr-3 bg-black/80 text-white px-3 py-2 rounded-lg text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
            <div className="flex items-center gap-2">
              Our Story
            </div>
            <div className="absolute top-1/2 -translate-y-1/2 -right-1 w-2 h-2 bg-black/80 rotate-45"></div>
          </div>
        </div>
      </div>
    </div>
  );
}